import ProgressIndicator from './progress-indicator';
import './progress-indicator.scss';

export default ProgressIndicator;
